export const getName = <O extends object>({ name }: { name?: string }, previous: O): O => {
  if (name) {
    const [firstName, ...last] = (name || '').split(' ');
    const lastName = last.join(' ');
    const n = [firstName, lastName];
    return Object.keys(previous).reduce(
      (acc, key, i) => ({
        ...acc,
        [key]: n[i],
      }),
      {} as O
    );
  }
  return previous;
};
